import { ExpandLess, ExpandMore, TableRestaurant } from "@mui/icons-material";
import { useState } from "react";
import { FormatNumber2 } from "./tools";

export const Card = (props) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen((pre) => !pre);
  };
  return (
    <>
      {!props.amount == 0 || !props.amount == null ? (
        <div
          onClick={() => {
            if (props.t === "Running Table") {
              handleClick();
            }
          }}
          className=" group w-full "
        >
          <div className={`dashboard-value-card ${open ? "is-open" : ""}`}>
            <div className="flex">
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  width: "95%",
                  flexDirection: "row",
                  textOverflow: "ellipsis",
                  justifyContent: "space-between",
                }}
              >
                {props.t === "Running Table" ? (
                  <TableRestaurant
                    fontSize="15"
                    color={"primary"}
                    sx={{ marginRight: 1 }}
                  />
                ) : null}
                <span className="dashboard-value-label">
                  {props.t === "Running Table" ? (
                    "Running"
                  ) : props.t ? (
                    <div className="flex items-center">
                      <div>{props.t}</div>
                      {props?.color && (
                        <div
                          style={{
                            backgroundColor: props?.color,
                          }}
                          className="h-[10px] ml-2 w-[10px] rounded-lg"
                        ></div>
                      )}
                    </div>
                  ) : (
                    <div className="h-[21px]" />
                  )}
                </span>
              </div>
              {props.t === "Running Table" ? (
                open ? (
                  <ExpandLess color="primary" />
                ) : (
                  <ExpandMore className="ml-2" color="primary" />
                )
              ) : null}
            </div>
            <div className="dashboard-value-amount">
              ₹ {FormatNumber2(props.amount)}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
